import { Component, HostListener, inject } from '@angular/core';
import {
  IxConfirmationComponent,
  IxNgComValidationService,
  IxNgConfirmationService,
  IxNgHtmlUtilsService,
  IxNgMenuService,
  IxNgTopbarService,
} from 'ix-ng-components';
import { Title } from '@angular/platform-browser';
import { FooterComponent, LayoutService } from 'projects/vpo-shared/src/public-api';
import { environment } from 'vpo-shared';
import { Toast } from 'primeng/toast';
import { ValidationDialogComponent } from 'projects/vpo-shared/src/lib/validation/validation-dialog/validation-dialog.component';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { AsyncPipe, NgClass } from '@angular/common';
import { BlockUI } from 'primeng/blockui';
import { TopbarComponent } from './topbar/topbar.component';
import { AppService } from '../../../vpo-shared/src/lib/services/app.service';
import { BlockUiService } from '../../../vpo-shared/src/lib/block-ui/block-ui-service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    TopbarComponent,
    Toast,
    IxConfirmationComponent,
    ValidationDialogComponent,
    RouterOutlet,
    FooterComponent,
    ConfirmDialog,
    NgClass,
    BlockUI,
    AsyncPipe,
  ],
})
export class AppComponent {
  protected readonly environment = environment;
  protected ixNgComValidationService = inject(IxNgComValidationService);
  protected ixNgConfirmationService = inject(IxNgConfirmationService);
  protected ixNgMenuService = inject(IxNgMenuService);
  protected ixNgTopbarService = inject(IxNgTopbarService);
  protected layoutService = inject(LayoutService);
  public blockUiService = inject(BlockUiService);
  public appService = inject(AppService);

  constructor() {
    const titleService = inject(Title);
    const ixNgHtmlUtilsService = inject(IxNgHtmlUtilsService);

    ixNgHtmlUtilsService.changeToOverlayMenu();
    this.ixNgTopbarService.logoRouterLink = ['/main', 'namizje'];

    titleService.setTitle('VPO2327');
  }

  @HostListener('click', ['$event'])
  onClick() {
    if (!this.ixNgMenuService.menuClick && !this.ixNgMenuService.menuButtonClick) {
      this.ixNgMenuService.mobileMenuActive = false;
      this.ixNgMenuService.overlayMenuActive = false;
      this.ixNgMenuService.resetSlim = true;
    }

    if (!this.ixNgTopbarService.topbarMenuClick && !this.ixNgTopbarService.topbarMenuButtonClick) {
      this.layoutService.layoutTopbarMenuActive = false;
      this.ixNgTopbarService.topbarMenuActive = false;
    }

    this.ixNgMenuService.menuClick = false;
    this.ixNgMenuService.menuButtonClick = false;
    this.ixNgTopbarService.topbarMenuClick = false;
    this.ixNgTopbarService.topbarMenuButtonClick = false;
  }
}
